<template>
  <div class="page-container">
    <a-page-header class="page-header" @back="handleBack">
      <div slot="title" style="cursor: pointer" @click="handleBack">
        返回
        <span v-for="(item, index) in titleList" :key="index">
          <span :style="{ color: index == titleList.length - 1 ? '#297ede' : '' }">{{ item }}</span>
          <span v-if="index < titleList.length - 1" style="padding: 0 2px">/</span>
        </span>
      </div>
    </a-page-header>
    <component
      :is="componentList[componentType]"
      :type="componentType"
      :classId="classId"
      :titleList="titleList"
      :recordData="recordData"
      @addTitleList="addTitleList"
    />
  </div>
</template>
<script>
import RemindStuDetail from './components/RemindStuDetail'
import CareStudentRecord from './components/CareStudentRecord'
import AssessmentPlan from './components/AssessmentPlan'
import StudentStatusRecord from './components/StudentStatusRecord'
import MoodRecordDetail from './components/MoodRecordDetail'
import CampusActivities from './components/CampusActivities'

export default {
  name: 'ClassOverviewDetail',
  components: {
    RemindStuDetail,
    CareStudentRecord,
    AssessmentPlan,
    StudentStatusRecord,
    MoodRecordDetail,
    CampusActivities,
  },
  data() {
    return {
      componentType: '',
      classId: '',
      titleList: ['班级心情'],
      componentList: {
        1: 'RemindStuDetail',
        2: 'CareStudentRecord',
        3: 'AssessmentPlan',
        4: 'AssessmentPlan',
        5: 'StudentStatusRecord',
        6: 'MoodRecordDetail',
        7: 'CampusActivities',
      },
      pageTitleLObj: {
        3: '我的计划',
        4: '我的计划',
        5: '愉悦人数',
        6: '心情记录',
        7: '校园活动',
      },
      recordData: {},
    }
  },
  created() {
    console.log('路由记录：', this.$router.history.current.query)
    const { type, classId } = this.$router.history.current.query
    this.recordData = this.$router.history.current.query
    if (type) {
      this.componentType = type
      this.classId = classId
    }
    if (this.pageTitleLObj[type]) {
      this.titleList.push(this.pageTitleLObj[type])
    }
  },
  methods: {
    handleBack() {
      if (
        (this.componentType === '3' || this.componentType === '4') &&
        this.titleList.length === 3
      ) {
        this.titleList.pop()
        return
      }
      this.$router.go(-1)
    },
    addTitleList(title) {
      this.titleList.push(title)
    },
  },
}
</script>
<style scoped lang="less">
.page-header {
  padding: 0 0 10px 0;
  border-bottom: 1px solid #eee;
  /deep/ .ant-page-header-heading-title {
    font-size: 14px;
  }
}
</style>
